import * as React from 'react';
import { DashboardComponentPlaceholder } from '../../Dashboard/Dashboard.styled';
import { DashboardError } from '../../Dashboard/DashboardError';
import * as Styled from './DashboardEditComponent.styled';
import { ComponentProvider } from '../../../ComponentProvider/ComponentProvider';
import { PrimaryButton } from '@fluentui/react/lib/Button';
import { EventType, UsageEventName } from '../../../../Models/UsageTelemetry';
import { ComponentContext } from '../../../../Context/ComponentContext';
export const DashboardEditComponent = (props) => {
    const { onUpdate, index, componentConfig, dashboardConfig, columnWidth, offsetLeft, offsetTop, onDelete } = props;
    const { telemetryClient } = React.useContext(ComponentContext);
    const { current } = React.useRef({
        offsetTop: -1,
        offsetLeft: -1,
    });
    // Calculates the offset position when the mouse is clicked on a component initially
    const handleComponentSelected = (e) => {
        const clientRect = e.currentTarget.getBoundingClientRect();
        current.offsetTop = e.clientY - clientRect.top;
        current.offsetLeft = e.clientX - clientRect.left;
    };
    const handleComponentDragged = (e) => {
        const top = Math.floor((e.pageY - current.offsetTop - offsetTop) / (dashboardConfig.rowHeight + dashboardConfig.gutter));
        const left = Math.floor((e.pageX - current.offsetLeft - offsetLeft) / (columnWidth + dashboardConfig.gutter));
        onUpdate(index, top, left);
    };
    const handleRemoveButtonClicked = () => {
        const removeCardEvent = {
            feature: 'DemoApp',
            subFeature: `Dashboard.Remove.${props.componentConfig.name.toString()}`,
            type: EventType.User,
            eventName: UsageEventName.ButtonClicked,
            businessTransactionId: props.componentConfig.name.toString(),
        };
        telemetryClient.trackEvent(removeCardEvent);
        onDelete(index);
    };
    return (React.createElement(Styled.Root, Object.assign({}, dashboardConfig, componentConfig, { onMouseDown: handleComponentSelected, onDrag: handleComponentDragged, draggable: true }),
        React.createElement(Styled.DeleteButton, null,
            React.createElement(PrimaryButton, { text: "Remove", onClick: handleRemoveButtonClicked }),
            ' '),
        React.createElement(ComponentProvider, { config: componentConfig, data: componentConfig.data, renderPlaceholder: () => React.createElement(DashboardComponentPlaceholder, null), renderError: () => React.createElement(DashboardError, null) })));
};
//# sourceMappingURL=DashboardEditComponent.js.map